import { Card, List } from 'antd';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import UserAvatar from '../../../components/UserAvatar';
import UserGroupUserEmptyList from './UserGroupUserEmptyList';
import UserGroupUserListActions from './UserGroupUserListActions';

export type UserGroupUserListProps = { userGroup: UserGroupSpecsFragment };

const UserGroupUserList = ({ userGroup }: UserGroupUserListProps) => {
    if (userGroup.users.length === 0) {
        return <UserGroupUserEmptyList userGroup={userGroup} />;
    }

    return (
        <Card>
            <List>
                {userGroup.users.map(user => (
                    <List.Item key={user.id} extra={<UserGroupUserListActions user={user} userGroup={userGroup} />}>
                        <List.Item.Meta avatar={<UserAvatar user={user} />} title={user.displayName} />
                    </List.Item>
                ))}
            </List>
        </Card>
    );
};

export default UserGroupUserList;
